import React from 'react'

import Loader from './utils/Loader'

export default function GeneralLoader() {
    return (
        <div className="pt2 pb2">
            <Loader />
        </div>
    )
}



// WEBPACK FOOTER //
// ./src/components/GeneralLoader.js